import API from "../../../../app/api";

export const addWishlist = async (payload) => {
  const response = await API.post("/wishlist", payload);
  return response.data;
};

export const removeWishlist = async (wishlistId) => {
  const response = await API.delete(`/wishlist/${wishlistId}`);
  return response.data;
};

export const getWishlist = async (userId, customerId) => {
  const response = await API.get("/wishlist");

  return response.data;
};